<app-section #parentSection
             [formGroup]="formGroup"
             [formConfig]="formConfig"
             [sectionRef]="section"
             [title]="title"
             class="logged-user-section"
             *ngIf="sectionVisible"
             [containerClass]="true">

  <ng-template #section>

    <div class="col">
      <div class="section__component col-50">
        <app-text-field [bean]="bean"
                        [errorsMap]="formFactoryService.errorsMap"
                        [control]="formGroup.controls[consts.VIN]"
                        [fieldConfig]="formFactoryService.fieldConfig(consts.VIN, formConfig)"
                        [context]="formConfig.formKey"
                        [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.VIN)]"
        >
        </app-text-field>
      </div>
    </div>
  </ng-template>
</app-section>
